import { createAsyncThunk } from '@reduxjs/toolkit';
import { isProdEnv } from '../../../../common/environment';
import { StoreState } from '../../../../store/store.interface';
import { ActionStatus } from '../../../../common/constants/action-status';

/**
 * Create braintree Google Pay instance only once.
 */
export const createGooglePaymentClient = createAsyncThunk(
  'braintree/createGooglePaymentClient',
  async (_data: any, thunkAPI) => {
    try {
      const googleEnv = isProdEnv() ? 'PRODUCTION' : 'TEST';
      console.log(`Google Pay Client: googleEnv ${googleEnv}`);
      return new google.payments.api.PaymentsClient({
        environment: googleEnv,
      });
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (_arg, { getState }) => {
      const state = getState() as StoreState;
      if (
        state.braintreeState.googlePaymentClient.status === ActionStatus.loading ||
        state.braintreeState.googlePaymentClient.status === ActionStatus.succeeded
      ) {
        return false;
      }
      return true;
    },
  }
);
